// @flow
import React from 'react';
import Button from '@atlaskit/button';
import Spinner from '@atlaskit/spinner';
import Modal, { ModalBody, ModalFooter, ModalHeader, ModalTitle, ModalTransition } from '@atlaskit/modal-dialog';

export default function DeleteLabelModal({ setIsOpen, confirm, loading, label, ...props }) {
    return (
        <ModalTransition>
            <Modal {...props} shouldScrollInViewport onClose={() => setIsOpen(false)}>
                <ModalHeader>
                    <ModalTitle>Delete {label.name}</ModalTitle>
                </ModalHeader>
                <ModalBody>
                    <p>Are you sure you want to delete this label?</p>
                </ModalBody>
                <ModalFooter>
                    <Button
                        isDisabled={loading}
                        iconAfter={loading ? <Spinner size="small" /> : null}
                        appearance="warning"
                        id="delete"
                        onClick={() => confirm(label.id)}
                    >
                        Delete
                    </Button>
                    <Button isDisabled={loading} id="cancel" onClick={() => setIsOpen(false)}>
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal>
        </ModalTransition>
    );
}
